import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

export class CustomLoader implements TranslateLoader {
  private http = inject(HttpClient);

  private readonly cacheVersion = '1f9d127e';

  public getTranslation(lang: string): Observable<any> {
    return this.http.get(`/assets/i18n/${lang}.json?v=${this.cacheVersion}`);
  }
}
